
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BlogPostListingItem.css';
import {
  Row,
  Col
} from 'react-bootstrap';
import cx from 'classnames';
import * as FontAwesome from 'react-icons/lib/fa';

// Locale
import messages from '../../../locale/messages';

import { formatURL } from '../../../helpers/formatURL';
import { isRTL } from '../../../helpers/formatLocale';

class BlogPostListingItem extends React.Component {

  constructor(props) {
    super(props);
    this.swiper = null;
  }

  static propTypes = {
    /* formatMessage: PropTypes.func, */
    id: PropTypes.number,
    pageUrl: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    coverPhoto: PropTypes.number,
  };

  render() {
    /* const { formatMessage } = this.props.intl; */
    const {
      id,
      pageUrl,
      title,
      date,
      description,
      coverPhotoName,
      locale,
      rtl
    } = this.props;

    const maxDescriptionLength = 380;
    let descriptionTruncated = '';
    let descriptionLength = description.length;
    if( descriptionLength <= maxDescriptionLength ) {
      descriptionTruncated = description;
    }
    else {
      let descriptionRest = description.substring(maxDescriptionLength);
      let descriptionRestBoundaryPosition = descriptionRest.search(/((?=^\s)|(?<!^)\b)/);
      descriptionTruncated = description.substring(0, maxDescriptionLength+descriptionRestBoundaryPosition+1).trim() + '...';
    }
    
    let coverPhotoFilename = coverPhotoName ? 'thumbnail-' + coverPhotoName : 'blogplaceholder.jpg';

    let dateTime = new Date(date);

    let dateFormated = new Intl.DateTimeFormat(locale, { dateStyle: 'full' }).format(dateTime);
    
    return (
      <div className={cx(s.listItemContainer)}>
        <div className={s.displayGridListing}>
          <div className={cx(s.listPhotoContainer)}>
            <a href={"/page/" + pageUrl}>
              <img className={cx(s.displayImage)} src={'/images/blog/' + coverPhotoFilename} />
            </a>
          </div>
          <div className={s.listInfo}>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <h2 className={cx(s.textEllipsis, s.listingTitle, 'textReversing', s.listTitleSection)}>
                    <a className={s.listInfoLink} href={"/page/" + pageUrl}>{title}</a>
                  </h2>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={s.blogDate}><time datetime={dateTime.toISOString()}>{dateFormated}</time></div>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} className={s.spaceTop1}>
                  <p>{descriptionTruncated}</p>
                </Col>
              </Row>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  locale: state.intl.locale
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(BlogPostListingItem)));


// WEBPACK FOOTER //
// src/components/BlogHomepageListings/BlogPostListingItem/BlogPostListingItem.js